// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { LookUp } from './lookup';
import { Tooltip } from './tooltip';
import { redirect } from './form-redirect';

/**
 * @class Jsw.ObjectSwitcher
 * @extends Jsw.LookUp
 */
export const ObjectSwitcher = Class.create(LookUp, {
    _tag: 'span',

    _initConfiguration($super, config) {
        $super(config);

        this._cls = this._getConfigParam('cls', 'btn-group object-switcher');
        this._listUrl = this._getConfigParam('listUrl', '');
        this._itemUrlTemplate = this._getConfigParam('itemUrlTemplate', '');
        this._owner = this._getConfigParam('owner', null);
    },

    _initCustomLookUpComponent() {
        this._customLookUpComponent = new Element('button', { type: 'button', class: 'btn dropdown-toggle' })
            .update('···');
        this._componentElement.insert(this._customLookUpComponent);
    },

    _addEvents($super) {
        $super();

        this.addEventObserver('component:change', function () {
            redirect(this._itemUrlTemplate.interpolate(this._currentValue, /(^|.|\r|\n)(%%(\w+)%%)/));
        }.bind(this));
    },

    _getSearchMoreText($super, count) {
        return $super(count)
            + (this._listUrl ? ` ${this.lmsg('refineSearchMessage', { link: `<a href="${this._listUrl}">${this.lmsg('listOfAllObjects')}</a>` })}` : '');
    },

    _updateData(data) {
        this._clearData();

        let myData = [];

        if (null !== this._owner) {
            myData = data.filter(function (item) {
                return 1 == item.isSameParent;
            });

            data = data.filter(function (item) {
                return 1 != item.isSameParent;
            });
        }

        let itemElement;
        const insertTo = this._emptyElement;
        if (myData.length) {
            if (data.length) {
                this._dropdownList.insert(new Element('li', { class: 'dropdown-header' })
                    .update(this.lmsg('myObjectsLabel', { name: this._owner })));
            }

            myData.each(function (item) {
                this._dropdownList.insert(this._createItem(item));
            }.bind(this));

            if (data.length) {
                this._dropdownList.insert(new Element('li', { class: 'divider' }));
                this._dropdownList.insert(new Element('li', { class: 'dropdown-header' })
                    .update(this.lmsg('otherObjectsLabel')));
            }
        }

        data.each(function (item) {
            this._dropdownList.insert(this._createItem(item));
        }.bind(this));

        this._addSearchMoreElement();
    },

    _addTooltips() {
        this._tooltip = Tooltip.init(this._customLookUpComponent, { text: this.lmsg('description') });
    },
});



// WEBPACK FOOTER //
// ./jsw/object-switcher.js